<!-- 新闻详情 -->
<template>
  <div class="newsDetails">
    <div class="detailsBg">
      <img :src="bgImg" alt srcset />
      <div class="text width">
        <div class="title">新闻动态</div>
        <div class="introduce">行业新闻动态，了解最新资讯</div>
      </div>
    </div>
    <div class="newContent width">
      <div class="contentItemLeft boxshadow">
        <div
          class="itemLeftItem"
          v-for="(item,i) in leftItem"
          :key="i"
          @click="gotoDetails(item.id)"
        >
          <div class="news-img">
            <img :src="item.cover_photo" alt srcset />
          </div>
          <div class="news-content">
            <div class="news-content-title">{{item.title}}</div>
            <div class="news-content-con">{{item.briefi_content}}</div>
            <div class="news-time">{{item.create_time | formatDate1}}</div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pages.currentPage"
          :page-size="10"
          layout="total,prev, pager, next, jumper"
          :total="pages.total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
      <div class="contentItemRight">
        <el-form :inline="true" :model="formInline" class="boxshadow" size="medium">
          <el-form-item style="margin-left:60px">
            <el-input v-model="formInline.title" placeholder="请输入文章标题"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSub()">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="hotList boxshadow">
          <h3>热门关注</h3>
          <div
            class="hotListItem"
            v-for="(item,i) in rightItem"
            :key="i"
            @click="gotoDetails(item.id)"
          >
            <div class="hotListTitle">{{item.title}}</div>
            <div class="hotTime">{{item.create_time | formatDate2}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { Footer },
  props: {},
  data() {
    return {
      bgImg: require('../assets/images/u0.jpg'),
      leftItem: [],
      pages: { names: '', currentPage: 1, total: 10 },
      rightItem: [],
      formInline: {
        title: '',
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getGoodsDetail()
  },
  mounted() {},
  methods: {
    async getGoodsDetail() {
      const res = await this.$http.post('/getAllNews ', {
        pages: this.pages.currentPage,
        names: this.pages.names,
      })
      this.leftItem = res.data.data.dataone.items
      this.pages.total = res.data.data.dataone.total
      this.rightItem = res.data.data.datatwo.items
    },

    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.pages.currentPage = val
      this.getGoodsDetail()
    },
    // 搜索
    onSub() {
      this.pages.names = this.formInline.title
      this.getGoodsDetail()
    },
    // 点击跳转到详情页
    gotoDetails(i) {
      this.$router.push({
        path: '/newsdetails',
        query: {
          //通过query 传递参数
          goodsDetail: i,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.detailsBg {
  position: relative;
  height: 450px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
  .text {
    position: absolute;
    top: 120px;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    .title {
      font-weight: 700;
      font-size: 32px;
      color: #fff;
    }
    .introduce {
      font-size: 18px;
      color: #fff;
      margin-top: 30px;
    }
  }
}
.newContent {
  display: flex;
  margin-bottom: 10px !important;
  .contentItemLeft {
    background-color: #fff;
    flex: 2;
    padding: 10px 20px 0 20px;
    border-radius: 4px;
    .itemLeftItem {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
      cursor: pointer;
      .news-img {
        flex: 1;
        margin-right: 30px;
        img {
          width: 100%;
        }
      }
      .news-content {
        flex: 4;
        .news-content-title {
          color: #333;
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          margin-bottom: 10px;
          margin-top: 10px;
        }
        .news-content-con {
          color: #333;
          line-height: 18px;
        }
        .news-time {
          color: #333;
          text-align: left;
          font-weight: 400;
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }
  }
  .contentItemRight {
    flex: 1;
    margin-left: 20px;
    .el-form {
      background-color: #fff;
      border-radius: 4px;
      padding-top: 20px;
    }
    .hotList {
      background-color: #fff;
      border-radius: 4px;
      padding: 20px;
      margin-top: 20px;
      h3 {
        text-align: center;
        margin: 0 0 10px 0;
      }
      .hotListItem {
        margin-bottom: 20px;
        cursor: pointer;
        .hotListTitle {
          margin-bottom: 10px;
        }
      }
    }
  }
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
}
</style>